import { render, staticRenderFns } from "./processPro.vue?vue&type=template&id=c65f0d74&"
import script from "./processPro.vue?vue&type=script&lang=js&"
export * from "./processPro.vue?vue&type=script&lang=js&"
import style0 from "./processPro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "processPro.vue"
export default component.exports